import { ApiClient } from '../../../infra';
import { fromBackend, toBackend } from '../../../domain';
/**
 * Uma leitura, uma hora ou um dia do historico como o painel os le: cada instante no fuso
 * de quem olha (ver `domain/instant.ts`). O historico compartilhado devolve a mesma forma e
 * usa os mesmos tres.
 */
export function historyValueFromBackend(value) {
    return { ...value, date: fromBackend(value.date) };
}
export function historyEntryFromBackend(entry) {
    return {
        ...entry,
        date: fromBackend(entry.date),
        expirationDate: fromBackend(entry.expirationDate),
        values: (entry.values ?? []).map(historyValueFromBackend)
    };
}
export function historyPageFromBackend(page) {
    return { ...page, elements: (page.elements ?? []).map(historyEntryFromBackend) };
}
/**
 * O que a ficha de um paciente pede ao servidor.
 *
 * Mora com o apresentador GENERICO porque e ele quem pergunta, nas duas montagens.
 */
export class PatientDetailApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new PatientDetailApi(); }
    async fetchCollaborator(patientId) {
        return (await this.client.send('GET', `/patient/admin/complete-data/${patientId}`));
    }
    async fetchTargets(patientId) {
        const targets = (await this.client.send('GET', `/measurement_targets/actives-by-patient/${patientId}`));
        return targets.map((target) => ({ ...target, date: fromBackend(target.date) }));
    }
    /** Os dias em que o paciente tem medicao, do mais recente para o mais antigo. */
    /**
     * Os dias com medicao de um paciente.
     *
     * `size` de um milhao, como o `daysLimit` da referencia: o endpoint pagina, a
     * tela nao, e a tabela pagina no cliente. Com os 60 de antes o porte mostrava
     * duas paginas onde a referencia mostra sete - o resto do historico simplesmente
     * nao chegava.
     */
    async fetchHistoryDays(patientId, size = 1_000_000) {
        // O rotulo de cada dia chega como a meia-noite de quem pede, em UTC, e volta a ser a
        // meia-noite aqui - e e dele que a tabela fatia o dia.
        return historyPageFromBackend((await this.client.send('POST', `/patient/admin/history-days/${patientId}`, {
            page: { number: 0, size }
        })));
    }
    /**
     * As leituras de UM dia.
     *
     * A janela vai de `T00:00:00` a `T23:59:59` explicitamente. O painel antigo
     * manda `begin` e `end` no MESMO instante, o que hoje funciona porque o backend
     * trunca a hora - mas ele chega la por `new Date(dia).toISOString()`, e essa
     * volta pelo UTC muda o dia em qualquer fuso de deslocamento positivo. Sem
     * `Date` no caminho nao ha o que escorregar. Data pura o backend recusa:
     * testado, devolve lista vazia.
     */
    /**
     * As leituras que UMA celula resumiu.
     *
     * A tabela agrupa por hora, entao a celula deixou de ser uma leitura. Sem isto o
     * agrupamento teria TIRADO informacao: antes cada linha era uma leitura, e depois
     * de resumir nao haveria como chegar nelas.
     */
    async fetchBucketReadings(patientId, measurementTypeId, hour, signal) {
        // A hora da celula e a de quem olha; o balde, no servidor, e a hora UTC.
        const query = `measurementTypeId=${measurementTypeId}&hour=${encodeURIComponent(toBackend(hour))}`;
        const readings = (await this.client.send('GET', `/patient/admin/history/${patientId}/bucket?${query}`, undefined, signal));
        return readings.map(historyValueFromBackend);
    }
    async fetchHistoryOfDay(patientId, day, signal) {
        const date = day.slice(0, 10);
        // O servidor le o DIA de cada ponta no fuso de quem pede (`X-Timezone`). A meia-noite
        // crua seria, para ele, 21h da vespera em Brasilia - o clique no dia 26 abria o 25.
        return historyPageFromBackend((await this.client.send('POST', `/patient/admin/history/${patientId}`, {
            searchParameters: { begin: toBackend(`${date}T00:00:00`), end: toBackend(`${date}T23:59:59`) },
            page: { number: 0, size: 999999 }
        }, signal)));
    }
}
//# sourceMappingURL=patient-detail.api.js.map